import React, {useState} from 'react';
import {bool, object, func} from 'prop-types';

import {connect} from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableRowMenu.module.css';

const SystemTableRowMenu = ({
    filterBy,
    hidden,
    onToggleDeleteSystemEntityModal,
    setSystem,
    system,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setSystem(system);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleRemoveAssociation() {
        onToggleDeleteSystemEntityModal(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    filterBy === 'equipment' &&
                    <MenuItem onClick={handleRemoveAssociation}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/deleteIconColor.svg"
                        />
                        Remove System Association
                    </MenuItem>
                }
            </Menu>
        </React.Fragment>
    );
};

SystemTableRowMenu.defaultProps = {
    hidden: false
};

SystemTableRowMenu.propTypes = {
    system:    object,
    hidden:    bool,
    setSystem: func
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(SystemTableRowMenu);
